const lightBlue = '#F0F5F8';
const colorBlueBlack = '#0D223E';
const colorDarkBlack = '#212B36';

const table = theme => ({
	table: {
		//backgroundColor: 'green'
	},
	row: {
		'&:hover, &:nth-of-type(even):hover': {
			backgroundColor: lightBlue
		},
		'&:nth-of-type(even)': {
			backgroundColor: '#F1F1F1',
		},
	},
});

export {
	colorDarkBlack,
	colorBlueBlack,
  table
};


// WEBPACK FOOTER //
// ./src/js/components/Mui/styles.js